import React from 'react';
import cx from 'classnames';

import {Icon, IconTypes, Bar, Group, Color} from '@pexip/components';
import type {Quality} from '@pexip/peer-connection-stats';

import {SelfviewButton} from '../../SelfviewButton/SelfviewButton.view';
import {stopMouseEventPropagation} from '../../../utils/domEventsHandles';
import {TestId} from '../../../../test/testIds';
import {IN_MEETING_SELFVIEW_BUTTON_TRANSPARENCY} from '../../../constants';

import styles from './InMeetingSelfview.module.scss';

export const InMeetingSelfviewFooter: React.FC<{
    controlsVisible: boolean;
    isAudioInputMuted: boolean;
    isAudioInputDisabled?: boolean;
    isMobileDevice?: boolean;
    quality: Quality;
    areEffectsApplied: boolean;
    toggleFacingMode?: () => void;
    isMaximized?: boolean;
    setIsMaximized?: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({
    isMaximized,
    setIsMaximized,
    controlsVisible,
    isAudioInputMuted,
    isAudioInputDisabled = false,
    isMobileDevice,
    areEffectsApplied,
    toggleFacingMode,
}) => {
    return (
        <Bar className={styles.footer} position="absoluteBottom">
            {isAudioInputMuted && !isMaximized && (
                <Icon
                    className={cx(
                        isMobileDevice && 'mr-1',
                        {
                            'visibility-hidden': isAudioInputDisabled,
                        },
                        styles.mutedMicrophoneIndicator,
                    )}
                    color={Color.White}
                    source={IconTypes.IconMicrophoneOff}
                    size={isMobileDevice ? 'compact' : 'compact'}
                />
            )}
            <Group
                spacing="compact"
                justifyContent="center"
                modifier="fullWidth"
            >
                {isMobileDevice && isMaximized && (
                    <SelfviewButton
                        onClick={toggleFacingMode}
                        source={IconTypes.IconFlipCamera}
                        isMobileDevice={isMobileDevice}
                        className={cx(isMobileDevice && styles.mobile)}
                        onPointerDownCapture={stopMouseEventPropagation(true)}
                        onTouchStartCapture={(e: React.TouchEvent) =>
                            e.stopPropagation()
                        }
                        variant="neutral"
                        noHover={isMobileDevice}
                        backgroundTransparency={
                            IN_MEETING_SELFVIEW_BUTTON_TRANSPARENCY
                        }
                        data-testid={TestId.ButtonFlipCameraInMeetingSelfview}
                    />
                )}
                {!isMaximized && isMobileDevice && controlsVisible && (
                    <SelfviewButton
                        onClick={() => setIsMaximized?.(!isMaximized)}
                        isActive={areEffectsApplied}
                        source={IconTypes.IconFullscreenOn}
                        onPointerDownCapture={stopMouseEventPropagation(true)}
                        onTouchStartCapture={(e: React.TouchEvent) =>
                            e.stopPropagation()
                        }
                        isMobileDevice={isMobileDevice}
                        className={cx(
                            isMobileDevice && 'ml-1',
                            styles.expandSelfviewButton,
                            isMobileDevice && styles.mobile,
                        )}
                        variant="neutral"
                        noHover={isMobileDevice}
                        backgroundTransparency={
                            IN_MEETING_SELFVIEW_BUTTON_TRANSPARENCY
                        }
                    />
                )}
            </Group>
        </Bar>
    );
};
